namespace $ {

	export const $shm_hitalama_file_text_inline_limit = 16 * 1024

	export function $shm_hitalama_file_text_size( text: string ) {
		return $mol_charset_encode( text ).byteLength
	}

	export function $shm_hitalama_file_text_read( file: $shm_hitalama_file | null | undefined ) {
		if( !file ) return ''
		return file.file()?.str() ?? ''
	}

	export function $shm_hitalama_file_text_write(
		file: $shm_hitalama_file,
		text: string,
		title = 'text.txt',
	) {
		const content = file.file_ensure()
		if( !content ) throw new Error( 'Не удалось создать файловое хранилище текста' )

		content.str( text, 'text/plain;charset=utf-8' )
		file.title( title )
		file.Size( null )?.val( $shm_hitalama_file_text_size( text ) )
		return file
	}

}
